// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12AeU","tabsBox":"styles_tabsBox__2YQvj","createButton":"styles_createButton__y-Gvn"};